module.exports = __webpack_public_path__ + "static/media/sma.1f0f83fa.svg";